export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-20">
      <div className="text-xs font-semibold tracking-[0.2em] uppercase text-cyan-400 mb-4">About SonotekDigi</div>
      <h1 className="text-4xl sm:text-5xl font-bold tracking-tight">Music distribution, reimagined for the independent era.</h1>
      <div className="mt-10 space-y-6 text-zinc-400 leading-relaxed">
        <p>
          SonotekDigi is a premium distribution platform built for artists, labels, and independent creators
          who want a professional pipeline without the label overhead. We provide a secure submission workflow,
          transparent status tracking, and enterprise-grade metadata handling.
        </p>
        <p>
          Each artist gets a private, isolated dashboard. Your masters, artwork, and release metadata are yours —
          never mixed, never shared. Our review process moves through five clean states: Submitted, Under Review,
          Approved, Rejected, and Released.
        </p>
        <p>
          Whether you're releasing your first single or scaling a back catalog, SonotekDigi gives you the pipeline
          used by professionals with the simplicity independent artists deserve.
        </p>
      </div>
      <div className="mt-14 grid sm:grid-cols-3 gap-4">
        {[
          {k: "5", v: "Status stages"},
          {k: "24/7", v: "Delivery pipeline"},
          {k: "∞", v: "Catalog size"},
        ].map((s, i) => (
          <div key={i} className="p-6 rounded-2xl border border-zinc-800 bg-zinc-950/60">
            <div className="text-4xl font-bold gradient-text">{s.k}</div>
            <div className="mt-2 text-sm text-zinc-500 uppercase tracking-wider">{s.v}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
